{
  "comment": "M7 spec §12.1 (S1 owns): career.incomeMix keeps incomeBuckets rolling buckets of incomeBucketS game seconds (10 × 30 min ≈ 5 h of play). A source over dominantShare of the window's income gets its §9 retaliation row. Sources: a raw-ware (ore) sale books to wareSaleSource, a component sale (salvage, data cores) to componentSaleSource, a contract hand-in to combat when its type is in combatContractTypes, else to contracts. The kill and sale ring sizes stay in career-logs.json (D-340). Placeholders for the balance pass (M7 spec §15 item 4); tune freely.",
  "incomeBucketS": 1800,
  "incomeBuckets": 10,
  "dominantShare": 0.25,
  "wareSaleSource": "mining",
  "componentSaleSource": "salvage",
  "combatContractTypes": ["clearRaiders"]
}
